import { gql } from 'graphql-tag';
import { ApolloError, TypedDocumentNode, useQuery } from '@apollo/client';
import { RevenueDataQuery, RevenueDataQueryVariables, RevenueReport, RevenueScope } from '../../generated/graphql';

export type { RevenueItem, RevenueReport } from '../../generated/graphql';

const query: TypedDocumentNode<RevenueDataQuery, RevenueDataQueryVariables> = gql`
  query RevenueData($scope: RevenueScope!, $marketLocationId: ID!, $date: DateTime!) {
    revenueData(scope: $scope, marketLocationId: $marketLocationId, date: $date) {
      marketLocationId
      items {
        key
        amount
        price
        sum
      }
    }
  }
`;

export function useRevenueData(
  scope: RevenueScope,
  marketLocationId: string,
  date: Date,
): { data: RevenueReport | { items: [] }; error: ApolloError | undefined } {
  const { data, error } = useQuery(query, { variables: { scope, marketLocationId, date }, errorPolicy: 'all' });

  return { data: data?.revenueData ?? { items: [] }, error: error };
}
